import type { TemplateFormLanguage } from '../types/templateForms';
import { type ButtonTranslations, getButtonTranslations } from './buttons';
import { type ClientErrorTranslations, getClientErrorTranslations } from './clientError';
import { DEFAULT_TEMPLATE_FORM_LANGUAGE } from './constants';
import { type ContactInfoTranslations, getContactInfoTranslations } from './contactInfo';
import { type FileUploadTranslations, getFileUploadTranslations } from './fileUpload';
import {
    type FinancialSummaryTranslations,
    getFinancialSummaryTranslations,
} from './financialSummary';
import { type FormHeaderTranslations, getFormHeaderTranslations } from './formHeader';
import { type FormValidationTranslations, getFormValidationTranslations } from './formValidation';
import { type IntakeStatusTranslations, getIntakeStatusTranslations } from './intakeStatus';
import { type NotificationTranslations, getNotificationTranslations } from './notifications';
import { type RetainerTranslations, getRetainerTranslations } from './retainer';
import {
    type StaticStepLabelsTranslations,
    getStaticStepLabelsTranslations,
    getStaticStepLabel,
    getOrdinalContactLabel,
} from './staticStepLabels';
import { type VerifyEmailTranslations, getVerifyEmailTranslations } from './verifyEmail';

export interface IntakeFormTranslations {
    contactInfo: ContactInfoTranslations;
    formHeader: FormHeaderTranslations;
    buttons: ButtonTranslations;
    intakeStatus: IntakeStatusTranslations;
    formValidation: FormValidationTranslations;
    notifications: NotificationTranslations;
    verifyEmail: VerifyEmailTranslations;
    financialSummary: FinancialSummaryTranslations;
    retainer: RetainerTranslations;
    fileUpload: FileUploadTranslations;
    staticStepLabels: StaticStepLabelsTranslations;
    clientError: ClientErrorTranslations;
}

export function getIntakeFormTranslations(
    language: TemplateFormLanguage = DEFAULT_TEMPLATE_FORM_LANGUAGE,
): IntakeFormTranslations {
    return {
        contactInfo: getContactInfoTranslations(language),
        formHeader: getFormHeaderTranslations(language),
        buttons: getButtonTranslations(language),
        intakeStatus: getIntakeStatusTranslations(language),
        formValidation: getFormValidationTranslations(language),
        notifications: getNotificationTranslations(language),
        verifyEmail: getVerifyEmailTranslations(language),
        financialSummary: getFinancialSummaryTranslations(language),
        retainer: getRetainerTranslations(language),
        fileUpload: getFileUploadTranslations(language),
        staticStepLabels: getStaticStepLabelsTranslations(language),
        clientError: getClientErrorTranslations(language),
    };
}

export {
    DEFAULT_TEMPLATE_FORM_LANGUAGE,
    getContactInfoTranslations,
    getFormHeaderTranslations,
    getButtonTranslations,
    getIntakeStatusTranslations,
    getFormValidationTranslations,
    getNotificationTranslations,
    getVerifyEmailTranslations,
    getFinancialSummaryTranslations,
    getRetainerTranslations,
    getFileUploadTranslations,
    getStaticStepLabelsTranslations,
    getStaticStepLabel,
    getOrdinalContactLabel,
    getClientErrorTranslations,
};

export type {
    ContactInfoTranslations,
    FormHeaderTranslations,
    ButtonTranslations,
    IntakeStatusTranslations,
    FormValidationTranslations,
    NotificationTranslations,
    VerifyEmailTranslations,
    FinancialSummaryTranslations,
    RetainerTranslations,
    FileUploadTranslations,
    StaticStepLabelsTranslations,
    ClientErrorTranslations,
};
